import { render } from "./DNSDiagram.vue?vue&type=template&id=4c673112&scoped=true"
import script from "./DNSDiagram.vue?vue&type=script&lang=js"
export * from "./DNSDiagram.vue?vue&type=script&lang=js"

import "./DNSDiagram.vue?vue&type=style&index=0&id=4c673112&scoped=true&lang=css"
import "./DNSDiagram.vue?vue&type=style&index=1&id=4c673112&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c673112"]])

export default __exports__